// extracted by mini-css-extract-plugin
module.exports = {"results":"autocomplete_results__2WcCv","input":"autocomplete_input__E67Ny","closeIcon":"autocomplete_closeIcon__2HXd8"};